import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";

// Firma a dito/penna: restituisce un PNG (Blob). Nessuna libreria.
export default function SignaturePad({ label, onSave, saved }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    c.width = c.offsetWidth * 2;
    c.height = 160 * 2;
    ctx.scale(2, 2);
    ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { drawing.current = true; ref.current.setPointerCapture(e.pointerId); const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setDirty(true); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setDirty(false); };
  const save = () => ref.current.toBlob((b) => b && onSave(b), "image/png");

  return (
    <div className="space-y-2" data-testid="signature-pad">
      <p className="text-sm font-semibold">{label} {saved && <span className="ml-2 text-emerald-700">✓ firma acquisita</span>}</p>
      <canvas ref={ref} className="h-40 w-full touch-none rounded-lg border-2 border-dashed border-slate-400 bg-white"
        onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} aria-label={`Area di firma: ${label}`} />
      <div className="flex gap-2">
        <Button type="button" variant="outline" className="h-12 flex-1" onClick={clear}>Cancella</Button>
        <Button type="button" className="h-12 flex-1" disabled={!dirty} onClick={save}>Salva firma</Button>
      </div>
    </div>
  );
}
